import { Icon, Typography } from '@rbilabs/universal-components';
import { Pressable, StyleSheet, View } from 'react-native';

import { getDesignToken, primitive, spacing } from 'styles/constants';

import { IOrderStatusBarData } from './types';

export const TopOrderStatusBar = ({ data }: { data: IOrderStatusBarData }) => {
  if (!data) {
    return null;
  }

  return (
    <Pressable onPress={data.cta?.action} style={styles.pressableCta}>
      <View style={styles.left}>
        <Icon size={5} color={getDesignToken('icon-button-primary')} variant={data.icon} />
        <Typography
          ml="$1"
          fontFamily="heading"
          color={primitive.$white}
          maxFontSizeMultiplier={1.5}
        >
          {data.heading}
        </Typography>
      </View>
      <View style={styles.right}>
        <Typography fontSize="md" color={primitive.$white} maxFontSizeMultiplier={1.5}>
          {data.cta.text}
        </Typography>
        <Icon size="xs" name="custom:Next" color={getDesignToken('icon-button-primary')} />
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  pressableCta: {
    alignItems: 'center',
    paddingVertical: spacing.$2,
    flexDirection: 'row',
    alignContent: 'center',
  },
  left: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  right: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
});
